module.exports = __webpack_public_path__ + "media/images/emblems/Oberbuchsiten-blason-5c415856f833d027b42ccdd0d714486e.png";